import React, { Component } from 'react';
const products = [{
  name: 'CHMER CNC Series CM323C Die Sinker EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/1279f28cb3255850727918ed587b6acc/large-0000062_chmer-cnc-series-cm323c.jpg',
  href: '/listings/4738631-chmer-cnc-series-cm323c-die-sinker-edm-compound-table-design'
}, {
  name: 'CHMER CNC Series CM434C Die Sinker EDM',
  image: 'https://i.machineryhost.com/4a716f7ba05468f225127f29aa2040c5/5f42287623c5c4e91599301e3907f298/large-0000063_chmer-cnc-series-cm434c.jpg',
  href: '/listings/4738630-chmer-cnc-series-cm434c-die-sinker-edm-compound-table-design'
}];
export function ChmerStandardCNCSection() {
  return <section data-id="element-1945">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-1946">
        <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-1947">
          Chmer Standard CNC Series
        </h2>
      </div>
      <div className="bg-white p-6 md:p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-1948">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-1949">
          {products.map((product, pIndex) => <div key={pIndex} className="group bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" data-id="element-1950">
              <a href="/m7_view_item.html" className="bg-gray-50 p-6 h-56 flex items-center justify-center border-b border-gray-100 block" data-id="element-1951">
                <img src={product.image} alt={product.name} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500 block" data-id="element-1952" />
              </a>
              <div className="p-5 flex flex-col flex-grow" data-id="element-1953">
                <a href="/m7_view_item.html" className="no-underline" data-id="element-1954">
                  <h3 className="text-base font-bold text-navy mb-4 leading-tight group-hover:text-orange transition-colors" data-id="element-1955">
                    {product.name}
                  </h3>
                </a>
                <div className="mt-auto pt-4 border-t border-gray-100 flex flex-col space-y-2" data-id="element-1956">
                  <a href={`/ContactPeakMachineSales.html?i515589:default[Product%20Title]=${encodeURIComponent(product.name)}`} className="inline-flex items-center justify-center w-full bg-navy text-white px-4 py-2 rounded-md font-bold text-sm hover:bg-orange transition-colors no-underline" data-id="element-1957">
                    Request for Quote
                  </a>
                  <a href="/m7_view_item.html" className="inline-flex items-center justify-center w-full bg-gray-100 text-navy px-4 py-2 rounded-md font-bold text-sm hover:bg-gray-200 transition-colors no-underline" data-id="element-1958">
                    More Information
                  </a>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}